module.exports = __webpack_public_path__ + "img/approve-no.d8a20f78.png";